import React from 'react'

export const Footer = () => {
  return (
    <footer className='border-top py-3 my-5 position-relative bottom-0 start-50 translate-middle-x'>
      <p className='text-center'>Copyrights @2024</p>
    </footer>
  )
}
